// extracted by mini-css-extract-plugin
export default {"tablesList":"SheetFormTables_tablesList__C1sW3","tableWrapper":"SheetFormTables_tableWrapper__hCbI4"};